import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";

import logo from "../img/logoCirculo.png";
import "../css/header.css";

function Header() {
  var options = [
    "Marketing",
    "Servicio",
    "Arquitectura",
    "Carta",
    "Personal",
    "Franquicia",
  ];

  return (
    <div className="header text-center">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-4">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavAltMarkup"
                  aria-controls="navbarNavAltMarkup"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                  <div className="navbar-nav">
                    <a className="nav-link active" aria-current="page" href="#">
                      Inicio
                    </a>
                    <a className="nav-link" href="#">
                      Manuales
                    </a>
                    <a className="nav-link" href="#">
                      Franquicia
                    </a>
                    <a className="nav-link disabled" aria-disabled="true">
                      Empleados
                    </a>
                  </div>
                </div>
              </div>
            </nav>
          </div>
          <div className="col-4">
            <img className="logo" src={logo} />
          </div>
          <div className="col-4">
            <div className="input-group flex-nowrap ">
              <Typeahead
                className="form-control d-none d-sm-block"
                placeholder="¿Qué estás buscando?"
                id="selections-example"
                options={options}
                labelKey="label"
              />

              <div className="input-group-text pt-2 d-none d-sm-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  color={"#000000"}
                  fill={"none"}
                >
                  <path
                    d="M17.5 17.5L22 22"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>        
            </div>



            <div className="d-block d-sm-none">
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  color={"#000000"}
                  fill={"none"}
                >
                  <path
                    d="M17.5 17.5L22 22"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg></div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
